// @ts-check
import React from 'react';

import AlmaLinuxIcon from '@liquidweb-dev/undercurrent/icons/platform/AlmaLinux';
import CentOSIcon from '@liquidweb-dev/undercurrent/icons/platform/CentOS';
import DebianIcon from '@liquidweb-dev/undercurrent/icons/platform/Debian';
import FedoraIcon from '@liquidweb-dev/undercurrent/icons/platform/Fedora';
import LinuxIcon from '@liquidweb-dev/undercurrent/icons/platform/Linux';
import RockyIcon from '@liquidweb-dev/undercurrent/icons/platform/Rocky';
import UbuntuIcon from '@liquidweb-dev/undercurrent/icons/platform/Ubuntu';
import WindowsIcon from '@liquidweb-dev/undercurrent/icons/platform/Windows';

/** @param {import('@liquidweb-dev/undercurrent/types/svgTypes').FixedColorSvgProps & { os: import('modules/queries/asset/useDetails').AssetDetails['os'] }} props */
const OSIcon = ({ os, ...rest }) => {
	const osLowerCase = os.toLowerCase();

	if (osLowerCase.includes('alma')) {
		return <AlmaLinuxIcon {...rest} />;
	}

	if (osLowerCase.includes('centos')) {
		return <CentOSIcon {...rest} />;
	}

	if (osLowerCase.includes('debian')) {
		return <DebianIcon {...rest} />;
	}

	if (osLowerCase.includes('fedora')) {
		return <FedoraIcon {...rest} />;
	}

	if (osLowerCase.includes('rocky')) {
		return <RockyIcon {...rest} />;
	}

	if (osLowerCase.includes('ubuntu')) {
		return <UbuntuIcon {...rest} />;
	}

	if (osLowerCase.includes('windows')) {
		return <WindowsIcon {...rest} />;
	}

	if (
		osLowerCase.includes('linux') ||
		osLowerCase.includes('alpine') ||
		osLowerCase.includes('arch')
	) {
		return <LinuxIcon {...rest} />;
	}

	return null;
};

export default OSIcon;
